import React from "react";
import { StyledIndicator, StyledBoxIndicator } from "./onBehalfIndicator.style";
import Grid from '@mui/material/Grid';
import HlxButton from "component/commonComponents/button/button";
import { PeopleAlt } from '@mui/icons-material';
import Typography from "component/commonComponents/Typography";
import { HIDE_TOP_NAV_OPTIONS, PORTAL_CONFIG } from "../topNav/topNav";

export interface IOnBehalfIndicatorProps {
  title?: string;
  leftIcon?: React.ReactNode;
  description?: string;
  showCloseButton?: boolean;
  labelButton?: string;
  fullWidth?: boolean;
  onClose?: () => void;
}


const OnBehalfIndicator: React.FC<IOnBehalfIndicatorProps> = (props) => {
  const { leftIcon, title, description, showCloseButton, labelButton, fullWidth, onClose } = props;
  const { hideTopNav } = JSON.parse(sessionStorage.getItem(PORTAL_CONFIG) || '{}');
  const isHidePrimaryTopNav = [HIDE_TOP_NAV_OPTIONS.TRUE, HIDE_TOP_NAV_OPTIONS.PRIMARY].includes(hideTopNav);

  return (
    <StyledIndicator
      isHidePrimaryTopNav={isHidePrimaryTopNav}
      padding={fullWidth ? {
        xxs: '0 auto',
      } : {
        xs: "0px 16px",
        sm: "0px 16px",
      }}
    >
      <StyledBoxIndicator
        width={fullWidth ? {
          xxs: '100%',
        }: {
          xxs: '100%',
          xs: "100%",
          md: "1240px",
          xl: "1240px",
        }}
        padding={fullWidth ? {
          xxs: '0px 17px 0px',
          xs: '0px 17px 0px',
          sm: '0px 24px 0px',
          md: '0px 24px 0px',
          lg: '0px 152px 0px',
          xl: '0px 152px 0px',
          xxl: '0px 0px 0px',
        } : {
          xxs: '0px 10px 0px',
        }}
        justifyContent={showCloseButton ? "space-between" : "center"}
        alignItems="center"
      >
        <Grid
          container
          alignItems="center"
          spacing={2}
          justifyContent={showCloseButton ? "flex-start" : "center"}
        >
          <Grid item display={{ xs: "none", sm: "unset" }}>
            {leftIcon}
          </Grid>
          <Grid item>
            <Typography kind="regular" className="indicator-title">{title}</Typography>
            <Typography kind="regular" className="indicator-description">{description}</Typography>
          </Grid>
        </Grid>
        {showCloseButton && (
          <Grid item>
            <HlxButton
              variant="outlined"
              label={labelButton}
              onClick={onClose}
            />
          </Grid>
        )}
      </StyledBoxIndicator>
    </StyledIndicator>
    
  );
}

export const defaultProps: IOnBehalfIndicatorProps = {
  leftIcon: <PeopleAlt />,
  title: "You are ordering on behalf of: {{name}}",
  description: "",
  showCloseButton: false,
  labelButton: "END",
  fullWidth: false,
  onClose: () => { }
};

OnBehalfIndicator.defaultProps = defaultProps;

export default OnBehalfIndicator;

